import React from 'react';
import Button from 'fuse-ui/components/Button';
import PropTypes from 'prop-types';
import LoadingSectionWrapper from '../common/components/loading-section-wrapper';
import WhoisModalContent from './whois-modal-content';
import { withStyles } from '@material-ui/core/styles';

import Modal from '../modal/modal';

const styles = theme => ( {
    button: {
        margin: theme.spacing.unit,
    },
    textArea: {
        marginTop: theme.spacing.unit * 2
    }
} );


const WhoisModalContentWithLoading = LoadingSectionWrapper( WhoisModalContent );

class WhoisModal extends React.Component{
    render(){
        const {
            classes,
            subtitle,
            open,
            onClose,
            isLoading,
            dataAutomationId,
            whoisData
        } = this.props;

        const actions = (
            <Button onClick={onClose} color="primary" className={classes.button} data-automation-id={`whois-modal-close-btn`}>
                    Close
            </Button>
        );

        return (
            <Modal
                open={open}
                onClose={onClose}
                title="WhoIs"
                subTitle={subtitle}
                modalActions={actions}
                dataAutomationId={dataAutomationId}
            >
                <WhoisModalContentWithLoading whoisData={whoisData} isLoading={isLoading}/>
            </Modal>
        );
    }
};

WhoisModal.propTypes = {
    classes: PropTypes.object.isRequired,
    dataAutomationId: PropTypes.string.isRequired,
    isDisabled: PropTypes.bool,
    isLoading: PropTypes.bool,
    onChange: PropTypes.func,
    onClose: PropTypes.func,
    onSave: PropTypes.func,
    open: PropTypes.bool.isRequired,
    subtitle: PropTypes.string,
    title: PropTypes.string,
    whoisData: PropTypes.string.isRequired,
};

WhoisModal.defaultProps = {
    onChange: () => {},
    onClose: () => {},
    onSave: () => {},
    title: 'Add Notes'
};

export default withStyles( styles )( WhoisModal );
